<cac-dialog-layout [title]="'Edit Order Item'" 
    subtitle="Update quantity and override price for this order item"
    (onSubmit)="onSubmit($event)">
    <div class="p-6">
        <cac-form-builder [options]="form"></cac-form-builder>
    </div>
</cac-dialog-layout>